export default function onceChildAppends(el, selector, callback) {
  let timeout = null
  let observer = null

  if (find()) {
    timeout = setTimeout(check)
  } else {
    observer = new MutationObserver(check)
    observer.observe(el, { childList: true, subtree: true })
  }

  return { destroy }

  function destroy() {
    clearTimeout(timeout)
    observer?.disconnect()
  }

  function find() {
    return el.querySelector(selector)
  }

  function check() {
    const child = find()

    if (child) {
      destroy()
      callback(child)
    }
  }
}
